<template>
	<!-- 订单管理区域 - 上下布局设计，对标截图 -->
	<div v-if="isUserLoggedIn" class="order-management-container">
		<!-- 主选项卡：合约/期权 -->
		<div style="display: flex; gap: 0; margin-bottom: 0;">
			<div 
				:class="['main-tab-item', { 'main-tab-active': localMainOrderType === 'contract' }]"
				@click="handleMainOrderTypeChange('contract')"
			>
				{{ $t('Market.contract') || '合约' }}
			</div>
			<div 
				:class="['main-tab-item', { 'main-tab-active': localMainOrderType === 'options' }]"
				@click="handleMainOrderTypeChange('options')"
			>
				{{ $t('Market.options') || '期权' }}
			</div>
		</div>
		
		<!-- 上方：子选项卡和统计信息在同一行 -->
		<div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 0; margin-bottom: 10px;">
			<!-- 左侧：子选项卡 -->
			<div style="display: flex; gap: 0;">
				<div v-for="(item, index) in currentNavsList" :key="index"
					:class="localTabIndex === index ? 'tab-active' : 'tab-item'"
					@click="handleChangeTab(index)"
					:id="'tab' + index">
					{{ item }}
				</div>
			</div>

			<!-- 右侧：统计信息 -->
			<div class="order-stats" style="display: flex; gap: 30px; font-size: 13.5px;">
				<!-- 盈亏 - 所有tab都显示，根据订单类型分别计算 -->
			<div style="color: var(--text-secondary);">
				{{ $t('Trading.profitLoss') || 'Profit & Loss' }}: 
				<span :class="{'positive': hylist.yks > 0, 'negative': hylist.yks < 0}" style="font-weight: 500;">
					{{ formatProfit(hylist.yks) }}
				</span>
			</div>
				
		<!-- 余额 - 根据订单类型动态显示对应账户余额 -->
		<div style="color: var(--text-secondary);">
			{{ $t('Trading.balance') || 'Balance' }}: 
			<span 
				style="font-weight: 500;" 
				:style="{ color: currentAccountBalance < 0 ? '#dc3545' : 'var(--text-primary)' }"
			>
				{{ parseFloat(currentAccountBalance).toFixed(2) }}
			</span>
		</div>
				
				<!-- 保证金 - 仅合约模式显示 -->
				<div v-if="localMainOrderType === 'contract'" style="color: var(--text-secondary);">
					{{ $t('Trading.currentMargin') || 'Current Margin' }}: 
					<span style="font-weight: 500; color: var(--text-primary);">
						{{ parseFloat(hylist.caution_money || 0).toFixed(2) }}
					</span>
				</div>
			</div>
		</div>

		<!-- 下方：订单表格占据全宽 -->
		<div style="background: transparent; padding: 20px 0;padding-top: 0px;">
	<!-- 持仓订单（合约） -->
	<el-table v-if="localTabIndex === 0 && localMainOrderType === 'contract'" :data="indexList" :key="'contract-positions-' + tableKey" style="width: 100%; font-size: 13.5px;" :empty-text="''" :header-cell-style="{ background: 'transparent', color: '#666', fontSize: '13.5px', fontWeight: '500' }" :row-style="{ background: 'transparent' }" :cell-style="{ background: 'transparent', border: 'none' }">
			<template slot="empty">
				<div class="empty-state">
					<img src="@/assets/img/empty-image-search.png" alt="No Data" class="empty-image" />
					<p class="empty-text">{{ $t('order.no_data') || 'No Data' }}</p>
				</div>
			</template>
			<el-table-column :label="$t('Trading.symbol') || 'Transaction pairs'" min-width="80" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					<span>{{ scope.row.marketName || scope.row.symbol || scope.row.marketCode }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="id" :label="$t('balanceLog.orderId') || 'Reservation number'" min-width="120" align="center" show-overflow-tooltip />
			<el-table-column prop="type_name" :label="$t('Trading.direction')" min-width="120" align="center">
				<template slot-scope="scope">
					<div v-if="isBuyDirection(scope.row)" class="direction-tag direction-buy">
						{{ localMainOrderType === 'contract' ? $t('mai-ru') : $t('Trading.buyUp') }}
					</div>
					<div v-else class="direction-tag direction-sell">
						{{ localMainOrderType === 'contract' ? $t('mai-chu') : $t('Trading.buyDown') }}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="number" :label="$t('Trading.quantity') || 'Lots'" min-width="80" align="center" />
			<el-table-column prop="price" :label="$t('Trading.orderPrice') || 'Lower unit price'" min-width="100" align="center" show-overflow-tooltip />
			<el-table-column :label="$t('Trading.currentPrice') || 'Current price'" min-width="100" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					<span>{{ getRealTimePrice(scope.row) }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="caution_money" :label="$t('Trading.margin') || 'Margin'" min-width="100" align="center" show-overflow-tooltip />
			<!-- 手续费 -->
			<el-table-column :label="$t('Trading.fee') || '手续费'" min-width="100" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					<span>{{ scope.row.tradeFee || '0' }}</span>
				</template>
			</el-table-column>
			<!-- 止盈 -->
			<el-table-column :label="$t('Trading.stopLoss') || '止盈'" min-width="100" align="center">
				<template slot-scope="scope">
					<span>{{ formatStopValue(scope.row.target_profit_price || scope.row.stopLoss) }}</span>
				</template>
			</el-table-column>
			<!-- 止损 -->
			<el-table-column :label="$t('Trading.takeProfit') || '止损'" min-width="100" align="center">
				<template slot-scope="scope">
					<span>{{ formatStopValue(scope.row.stop_loss_price || scope.row.stopProfit) }}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('Trading.profitLoss') || 'Profit'" min-width="100" align="center">
				<template slot-scope="scope">
					<span :class="['profit-value', getOptionsRealTimeProfit(scope.row) >= 0 ? 'profit-positive' : 'profit-negative']">
						{{ formatProfit(getOptionsRealTimeProfit(scope.row)) }}
					</span>
				</template>
			</el-table-column>
				<el-table-column :label="$t('Trading.actions')" min-width="150" align="center">
					<template slot-scope="scope">
						<div style="display: flex; gap: 8px; justify-content: center;">
							<div @click="showTpSlModal(scope.row)" style="background: var(--primary-color, #0156DC); color: #ffffff; border-radius: 14px; height: 28px; line-height: 28px; text-align: center; font-size: 12.5px; cursor: pointer; display: inline-block; padding: 0 10px;">
								{{ $t('Trading.modifyTpSl') || '设置' }}
							</div>
							<div @click="handleClosePosition(scope.row)" style="background: #f23c48; color: #ffffff; border-radius: 14px; height: 28px; line-height: 28px; text-align: center; font-size: 12.5px; cursor: pointer; display: inline-block; padding: 0 10px;">
								{{ $t('Trading.closePosition') }}
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
			
		<!-- 交易中（期权） -->
		<el-table v-if="localTabIndex === 0 && localMainOrderType === 'options'" :data="indexList" style="width: 100%; font-size: 13.5px;" :empty-text="''" :header-cell-style="{ background: 'transparent', color: '#666', fontSize: '13.5px', fontWeight: '500' }" :row-style="{ background: 'transparent' }" :cell-style="{ background: 'transparent', border: 'none' }">
			<template slot="empty">
				<div class="empty-state">
					<img src="@/assets/img/empty-image-search.png" alt="No Data" class="empty-image" />
					<p class="empty-text">{{ $t('order.no_data') || 'No Data' }}</p>
				</div>
			</template>
			<!-- 交易对 -->
			<el-table-column :label="$t('Trading.symbol') || '交易对'" min-width="80" align="center">
				<template slot-scope="scope">
					<span>{{ scope.row.marketName || scope.row.symbol || scope.row.marketCode }}</span>
				</template>
			</el-table-column>
			
			<!-- 订单编号 -->
			<el-table-column prop="id" :label="$t('balanceLog.orderId') || '订单编号'" min-width="120" align="center" show-overflow-tooltip />
			
			<!-- 金额 -->
			<el-table-column :label="$t('Trading.investmentAmount') || '金额'" min-width="100" align="center">
				<template slot-scope="scope">
					<span>{{ scope.row.amount || scope.row.caution_money || 0 }}</span>
				</template>
			</el-table-column>
				
			<!-- 方向 -->
			<el-table-column :label="$t('Trading.direction') || '方向'" min-width="120" align="center">
				<template slot-scope="scope">
					<div v-if="scope.row.type === 1 || scope.row.type === '1'" class="direction-tag direction-buy">
						{{ $t('Trading.buyUp') || '买涨' }}
					</div>
					<div v-else class="direction-tag direction-sell">
						{{ $t('Trading.buyDown') || '买跌' }}
					</div>
				</template>
			</el-table-column>
			
			<!-- 下单价 -->
			<el-table-column :label="$t('Trading.orderPrice') || '下单价'" min-width="100" align="center">
				<template slot-scope="scope">
					<span>{{ scope.row.buyPrice || scope.row.price || 0 }}</span>
				</template>
			</el-table-column>
			
			<!-- 当前价 -->
			<el-table-column :label="$t('Trading.currentPrice') || '当前价'" min-width="100" align="center">
				<template slot-scope="scope">
					<span>{{ getRealTimePrice(scope.row) }}</span>
				</template>
			</el-table-column>
				
			<!-- 预计盈亏 -->
			<el-table-column :label="$t('Trading.profit') || '预计盈亏'" min-width="100" align="center">
				<template slot-scope="scope">
					<span :class="['profit-value', getOptionsRealTimeProfit(scope.row) >= 0 ? 'profit-positive' : 'profit-negative']">
						{{ formatProfit(getOptionsRealTimeProfit(scope.row)) }}
					</span>
				</template>
			</el-table-column>
				
				<!-- 时长/倒计时 -->
				<el-table-column :label="$t('Trading.timeLimit') || '时长'" min-width="100" align="center">
					<template slot-scope="scope">
						<div v-if="getOptionsCountdown(scope.row) > 0" class="countdown-display">
							{{ getOptionsCountdown(scope.row) }}s
						</div>
						<div v-else class="countdown-finished">
							{{ $t('Trading.completed') || '已结束' }}
						</div>
					</template>
				</el-table-column>
				
				<!-- 开盘时间 -->
				<el-table-column :label="$t('Trading.openTime') || '开盘时间'" min-width="150" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.createTime || scope.row.buyTime || '-' }}</span>
					</template>
				</el-table-column>
			</el-table>

			<!-- 挂单列表（仅合约） -->
			<el-table v-if="localTabIndex === 1 && localMainOrderType === 'contract'" :data="pendingOrders" style="width: 100%; font-size: 13.5px;" :empty-text="''" :header-cell-style="{ background: 'transparent', color: '#666', fontSize: '13.5px', fontWeight: '500' }" :row-style="{ background: 'transparent' }" :cell-style="{ background: 'transparent', border: 'none' }">
				<template slot="empty">
					<div class="empty-state">
						<img src="@/assets/img/empty-image-search.png" alt="No Data" class="empty-image" />
						<p class="empty-text">{{ $t('Trading.noPendingOrders') || 'No Pending Orders' }}</p>
					</div>
				</template>
				<el-table-column :label="$t('Trading.symbol') || 'Transaction pairs'" min-width="80" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{ scope.row.marketName || scope.row.symbol || scope.row.marketCode }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="id" :label="$t('balanceLog.orderId') || 'Reservation number'" min-width="120" align="center" show-overflow-tooltip />
				<el-table-column prop="type_name" :label="$t('Trading.direction')" min-width="120" align="center">
					<template slot-scope="scope">
						<div v-if="isBuyDirection(scope.row)" class="direction-tag direction-buy">
							{{ localMainOrderType === 'contract' ? $t('mai-ru') : $t('Trading.buyUp') }}
						</div>
						<div v-else class="direction-tag direction-sell">
							{{ localMainOrderType === 'contract' ? $t('mai-chu') : $t('Trading.buyDown') }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="number" :label="$t('Trading.quantity') || 'Lots'" min-width="80" align="center" />
				<el-table-column prop="price" :label="$t('Trading.orderPrice') || 'Lower unit price'" min-width="100" align="center" show-overflow-tooltip />
				<el-table-column :label="$t('Trading.currentPrice') || 'Current price'" min-width="100" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{ getRealTimePrice(scope.row) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="caution_money" :label="$t('Trading.margin') || 'Margin'" min-width="100" align="center" show-overflow-tooltip />
				<!-- 手续费 -->
				<el-table-column :label="$t('Trading.fee') || '手续费'" min-width="100" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{ scope.row.tradeFee || '0' }}</span>
					</template>
				</el-table-column>
				<!-- 止盈 -->
				<el-table-column :label="$t('Trading.stopLoss') || '止盈'" min-width="100" align="center">
					<template slot-scope="scope">
						<span>{{ formatStopValue(scope.row.target_profit_price || scope.row.stopLoss) }}</span>
					</template>
				</el-table-column>
				<!-- 止损 -->
				<el-table-column :label="$t('Trading.takeProfit') || '止损'" min-width="100" align="center">
					<template slot-scope="scope">
						<span>{{ formatStopValue(scope.row.stop_loss_price || scope.row.stopProfit) }}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('Trading.profitLoss') || 'Profit'" min-width="100" align="center">
					<template slot-scope="scope">
						<span :class="['profit-value', scope.row.upsdowns >= 0 ? 'profit-positive' : 'profit-negative']">
							{{ formatProfit(scope.row.upsdowns) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('Trading.actions')" min-width="100" align="center">
					<template slot-scope="scope">
						<div @click="handleCancelPendingOrder(scope.row)" style="background: #f23c48; color: #ffffff; border-radius: 14px; height: 28px; line-height: 28px; text-align: center; font-size: 12.5px; cursor: pointer; display: inline-block; padding: 0 10px;">
							{{ $t('Trading.cancel') || '撤单' }}
						</div>
					</template>
				</el-table-column>
			</el-table>

			<!-- 历史订单列表 -->
			<!-- 历史订单（合约的历史 或 期权的已平仓） -->
			<el-table v-if="(localTabIndex === 2 && localMainOrderType === 'contract') || (localTabIndex === 1 && localMainOrderType === 'options')" :data="historyOrders" style="width: 100%; font-size: 13.5px;" :empty-text="''" :header-cell-style="{ background: 'transparent', color: '#666', fontSize: '13.5px', fontWeight: '500' }" :row-style="{ background: 'transparent' }" :cell-style="{ background: 'transparent', border: 'none' }">
				<template slot="empty">
					<div class="empty-state">
						<img src="@/assets/img/empty-image-search.png" alt="No Data" class="empty-image" />
						<p class="empty-text">{{ $t('Trading.noHistory') || 'No History' }}</p>
					</div>
				</template>
			<!-- 交易对 -->
			<el-table-column prop="symbol" :label="$t('Trading.symbol')" min-width="80" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					<span>{{ scope.row.marketName || scope.row.symbol || scope.row.marketCode }}</span>
				</template>
			</el-table-column>

		<!-- 订单号 -->
		<el-table-column prop="id" :label="$t('balanceLog.orderId') || '订单编号'" min-width="120" align="center" show-overflow-tooltip>
			<template slot-scope="scope">
				<span>{{ scope.row.id }}</span>
			</template>
		</el-table-column>
			
			<!-- 金额（仅期权显示） -->
			<el-table-column v-if="localMainOrderType === 'options'" :label="$t('Trading.investmentAmount') || '金额'" min-width="100" align="center">
				<template slot-scope="scope">
					<span>{{ scope.row.amount || scope.row.caution_money || 0 }}</span>
				</template>
			</el-table-column>

				<!-- 方向 -->
				<el-table-column :label="$t('Trading.direction')" min-width="120" align="center">
					<template slot-scope="scope">
						<div v-if="isBuyDirection(scope.row)" class="direction-tag direction-buy">
							{{ localMainOrderType === 'contract' ? $t('mai-ru') : $t('Trading.buyUp') }}
						</div>
						<div v-else class="direction-tag direction-sell">
							{{ localMainOrderType === 'contract' ? $t('mai-chu') : $t('Trading.buyDown') }}
						</div>
					</template>
				</el-table-column>
				
				<!-- 时长（仅期权显示） -->
				<el-table-column v-if="localMainOrderType === 'options'" :label="$t('Trading.timeLimit') || '时长'" min-width="80" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.limitTime || 0 }}s</span>
					</template>
				</el-table-column>

				<!-- 买入价格（仅期权显示） -->
				<el-table-column v-if="localMainOrderType === 'options'" :label="$t('Trading.orderPrice') || '买入价格'" min-width="100" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.buyPrice || scope.row.price || '-' }}</span>
					</template>
				</el-table-column>

				<!-- 结束价格（仅期权显示） -->
				<el-table-column v-if="localMainOrderType === 'options'" :label="$t('Trading.closePrice') || '结束价格'" min-width="100" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.endPrice || scope.row.update_price || '-' }}</span>
					</template>
				</el-table-column>

				<!-- 手数/数量（仅合约显示） -->
				<el-table-column v-if="localMainOrderType === 'contract'" prop="number" :label="$t('Trading.quantity')" min-width="80" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.number || scope.row.hands || '-' }}</span>
					</template>
				</el-table-column>

				<!-- 下单价（仅合约显示） -->
				<el-table-column v-if="localMainOrderType === 'contract'" prop="price" :label="$t('Trading.orderPrice')" min-width="100" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{ scope.row.price || scope.row.buyPrice || '-' }}</span>
					</template>
				</el-table-column>

				<!-- 平仓价格（仅合约显示） -->
				<el-table-column v-if="localMainOrderType === 'contract'" :label="$t('Trading.closePrice')" min-width="100" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{ scope.row.sellPrice || scope.row.update_price || '-' }}</span>
					</template>
				</el-table-column>

			<!-- 保证金（仅合约显示） -->
			<el-table-column v-if="localMainOrderType === 'contract'" prop="caution_money" :label="$t('Trading.margin')" min-width="100" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					<span>{{ scope.row.caution_money || scope.row.margin || '-' }}</span>
				</template>
			</el-table-column>

			<!-- 手续费（仅合约显示） -->
			<el-table-column v-if="localMainOrderType === 'contract'" :label="$t('Trading.fee') || '手续费'" min-width="100" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					<span>{{ scope.row.tradeFee || '0' }}</span>
				</template>
			</el-table-column>

			<!-- 止盈（仅合约显示） -->
			<el-table-column v-if="localMainOrderType === 'contract'" :label="$t('Trading.stopLoss') || '止盈'" min-width="100" align="center">
					<template slot-scope="scope">
						<span>{{ formatStopValue(scope.row.target_profit_price || scope.row.stopLoss) }}</span>
					</template>
				</el-table-column>

				<!-- 止损（仅合约显示） -->
				<el-table-column v-if="localMainOrderType === 'contract'" :label="$t('Trading.takeProfit') || '止损'" min-width="100" align="center">
					<template slot-scope="scope">
						<span>{{ formatStopValue(scope.row.stop_loss_price || scope.row.stopProfit) }}</span>
					</template>
				</el-table-column>

				<!-- 盈亏 -->
				<el-table-column :label="$t('Trading.pnl')" min-width="100" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.profit !== null && scope.row.profit !== undefined">
							<span :class="['profit-value', parseFloat(scope.row.profit) >= 0 ? 'profit-positive' : 'profit-negative']">
								{{ parseFloat(scope.row.profit) >= 0 ? '+' : '' }}{{ formatProfit(scope.row.profit) }}
							</span>
						</span>
						<span v-else-if="scope.row.income !== null && scope.row.income !== undefined">
							<span :class="['profit-value', parseFloat(scope.row.income) >= 0 ? 'profit-positive' : 'profit-negative']">
								{{ parseFloat(scope.row.income) >= 0 ? '+' : '' }}{{ formatProfit(scope.row.income) }}
							</span>
						</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				
				<!-- 开盘时间（仅期权显示） -->
				<el-table-column v-if="localMainOrderType === 'options'" :label="$t('Trading.openTime') || '开盘时间'" min-width="150" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.createTime || scope.row.updateTime || '-' }}</span>
					</template>
				</el-table-column>

				<!-- 时间（仅合约显示） -->
				<el-table-column v-if="localMainOrderType === 'contract'" :label="$t('Trading.openTime')" min-width="130" align="center">
					<template slot-scope="scope">
						<div style="font-size: 13.5px;">
							{{ scope.row.updateTime || scope.row.transaction_time || scope.row.createTime || '-' }}
						</div>
					</template>
			</el-table-column>
		</el-table>
	</div>
	
	<!-- 止盈止损设置弹窗 -->
	<el-dialog
		:visible.sync="showTpSlDialog"
		:title="$t('Trading.tpslSettings') || '止盈止损设置'"
		width="450px"
		:close-on-click-modal="false"
		:append-to-body="true"
		:modal-append-to-body="true"
		class="tpsl-dialog"
	>
		<div v-if="selectedOrderForTpSl" class="tpsl-dialog-content">
			<!-- 订单信息 -->
			<div class="order-info-header">
				<div class="info-row">
					<span class="label">{{ $t('Trading.symbol') || '交易对' }}:</span>
					<span class="value">{{ selectedOrderForTpSl.marketName || selectedOrderForTpSl.symbol }}</span>
				</div>
				<div class="info-row">
					<span class="label">{{ $t('Trading.orderPrice') || '开仓价格' }}:</span>
					<span class="value">{{ selectedOrderForTpSl.price || 0 }}</span>
				</div>
			</div>
			
			<!-- 止损设置 -->
			<div class="tpsl-form-item">
				<div class="tpsl-checkbox-row">
					<el-checkbox v-model="tpSlForm.slEnabled">
						{{ $t('Trading.stopLoss') || '止损' }}
					</el-checkbox>
				</div>
				<el-input
					v-model.number="tpSlForm.slValue"
					type="number"
					:placeholder="$t('Trading.enterPrice') || '请输入价格'"
					:disabled="!tpSlForm.slEnabled"
					class="tpsl-input"
				/>
			</div>
			
			<!-- 止盈设置 -->
			<div class="tpsl-form-item">
				<div class="tpsl-checkbox-row">
					<el-checkbox v-model="tpSlForm.tpEnabled">
						{{ $t('Trading.takeProfit') || '止盈' }}
					</el-checkbox>
				</div>
				<el-input
					v-model.number="tpSlForm.tpValue"
					type="number"
					:placeholder="$t('Trading.enterPrice') || '请输入价格'"
					:disabled="!tpSlForm.tpEnabled"
					class="tpsl-input"
				/>
			</div>
		</div>
		
		<span slot="footer" class="dialog-footer">
			<el-button 
				class="tpsl-full-btn"
				type="primary" 
				@click="handleSubmitTpSl" 
				:loading="modifyingTpSl">
				{{ $t('common.confirm') || '确定' }}
			</el-button>
		</span>
	</el-dialog>
	
	<!-- 成功提示框 -->
	<div v-if="showSuccessModal" class="success-modal-overlay" @click="showSuccessModal = false">
		<div class="success-modal-content" @click.stop>
			<div class="success-icon">
				<svg viewBox="0 0 24 24" class="checkmark-simple">
					<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
				</svg>
			</div>
			<div class="success-text">{{ successMessage }}</div>
		</div>
	</div>
</div>
</template>

<script>
import { updateContractTpSl } from '@/api/market.js'

export default {
	name: 'OrderManagement',
		props: {
		isUserLoggedIn: Boolean,
		mainOrderType: String,
		tabIndex: Number,
		currentNavsList: Array,
		hylist: {
			type: Object,
			default: () => ({})
		},
		userInfo: {
			type: Object,
			default: () => ({})
		},
		users: {
			type: Object,
			default: () => ({})
		},
		indexList: {
			type: Array,
			default: () => []
		},
		pendingOrders: {
			type: Array,
			default: () => []
		},
		historyOrders: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
		localMainOrderType: this.mainOrderType,
		localTabIndex: this.tabIndex,
		countdownTimer: null,
		currentTime: Date.now(),
		tableKey: 0, // 用于强制表格重新渲染
		optionsProfitFluctuation: {}, // 存储每个订单的实时波动收益
		accountBalances: { // 账户余额数据
			spotBalance: 0,
			spotAvailable: 0,
			contractBalance: 0,
			contractAvailable: 0,
			optionBalance: 0,
			optionAvailable: 0
		},
		// 止盈止损弹窗相关
		showTpSlDialog: false,
		selectedOrderForTpSl: null,
		tpSlForm: {
			tpEnabled: false,
			tpValue: 0,
			slEnabled: false,
			slValue: 0
		},
		modifyingTpSl: false,
		// 成功提示框
		showSuccessModal: false,
		successMessage: '',
		
		// ✅ 余额刷新定时器
		balanceRefreshTimer: null
	}
},
	computed: {
		// 当前账户余额
		// ✅ 使用 Balance（总余额）而不是 Available（可用余额），以正确显示负数
		currentAccountBalance() {
			if (this.localMainOrderType === 'contract') {
				return this.accountBalances.contractBalance ?? 0;
			} else if (this.localMainOrderType === 'options') {
				return this.accountBalances.optionBalance ?? 0;
			}
			return this.accountBalances.spotBalance ?? 0;
		}
	},
	mounted() {
		// 启动倒计时定时器，每秒更新一次
		this.startCountdownTimer()
		// 获取账户余额
		this.fetchAccountBalances()
		
		// ✅ 每10秒刷新一次余额
		this.balanceRefreshTimer = setInterval(() => {
			if (this.isUserLoggedIn) {
				this.fetchAccountBalances();
			}
		}, 10000)
	},
	beforeDestroy() {
		// 清除倒计时定时器
		this.stopCountdownTimer()
		
		// ✅ 清理余额刷新定时器
		if (this.balanceRefreshTimer) {
			clearInterval(this.balanceRefreshTimer)
			this.balanceRefreshTimer = null
		}
	},
	watch: {
		// 监听登录状态变化
		isUserLoggedIn(val) {
			if (val) {
				// 用户登录后获取余额
				this.fetchAccountBalances();
			} else {
				// 用户登出后清空余额
				this.accountBalances = {
					spotBalance: 0,
					spotAvailable: 0,
					contractBalance: 0,
					contractAvailable: 0,
					optionBalance: 0,
					optionAvailable: 0
				};
			}
		},
		mainOrderType(val) {
			this.localMainOrderType = val
			// 切换订单类型时，清空波动数据，重新初始化
			this.optionsProfitFluctuation = {}
		},
		localMainOrderType(val) {
			// 切换订单类型时重新获取余额
			this.fetchAccountBalances()
		},
		tabIndex(val) {
			this.localTabIndex = val
		},
		// 监听 indexList 变化，当数据更新时重新初始化波动
		indexList: {
			handler(newVal, oldVal) {
				// 当订单列表变化时（比如切换订单类型后加载新数据），重置波动计算
				if (newVal !== oldVal && newVal && newVal.length > 0) {
					// 清空旧的波动数据
					this.optionsProfitFluctuation = {}
					// 立即更新一次波动数据
					this.updateOptionsProfitFluctuation()
					// 立即更新一次总盈亏
					this.updateTotalProfitLoss()
				}
			},
			deep: false,
			immediate: false
		}
	},
	methods: {
		// 格式化盈亏显示（去除末尾无意义的0）
	formatProfit(value) {
		if (value == null || value === '') return '0'
		const num = parseFloat(value)
		if (isNaN(num)) return '0'
		// 先保留5位小数，然后转换为字符串去除末尾的0
		return parseFloat(num.toFixed(5)).toString()
	},
	
	// 格式化止盈止损值
	formatStopValue(value) {
		// 如果是 null、undefined、空字符串、'-'，返回 '0'
		if (value == null || value === '' || value === '-') return '0'
		const num = parseFloat(value)
		// 如果无法转换为数字或者是 NaN，返回 '0'
		if (isNaN(num)) return '0'
		// 返回数字本身（包括 0）
		return num
	},
	
	// 获取账户余额
		async fetchAccountBalances() {
			if (!this.isUserLoggedIn) return;
			
			try {
				const request = (await import('@/utils/request')).default;
				const res = await request.get('/swx/customer/account/balances');
				if (res.code === 200 && res.result) {
					// ✅ 使用 ?? 而不是 ||，以正确处理负数余额
					this.accountBalances = {
						spotBalance: res.result.spotBalance ?? 0,
						spotAvailable: res.result.spotAvailable ?? 0,
						contractBalance: res.result.contractBalance ?? 0,
						contractAvailable: res.result.contractAvailable ?? 0,
						optionBalance: res.result.optionBalance ?? 0,
						optionAvailable: res.result.optionAvailable ?? 0
					};
				}
			} catch (error) {
				console.error('获取账户余额失败:', error);
			}
		},
	handleMainOrderTypeChange(type) {
		this.localMainOrderType = type
		this.localTabIndex = 0
		this.$emit('update:mainOrderType', type)
		this.$emit('update:tabIndex', 0)
		this.$emit('load-tab-data', 0, true) // 传递true表示强制刷新
	},
		handleChangeTab(index) {
			this.localTabIndex = index
			this.$emit('update:tabIndex', index)
			this.$emit('change-tab', index)
		},
	handleClosePosition(row) {
		this.$emit('close-position', row)
		// ✅ 移除延迟刷新，改由 home_pc.vue 在平仓成功后立即刷新
	},
	handleCancelPendingOrder(row) {
		this.$emit('cancel-pending-order', row)
		// ✅ 移除延迟刷新，改由 home_pc.vue 在撤单成功后立即刷新
	},
	getRealTimePrice(order) {
		if (!order) return '-';
		
		// 从 Vuex store 中的 marketWsList 获取实时价格
		const marketWsList = this.$store.state.marketWsList;
		
		// 优先使用订单的 marketCode 去匹配行情数据的 code
		const marketCode = order.marketCode || order.code;
		
		// 调试日志（开发时使用，生产环境可删除）
		if (process.env.NODE_ENV === 'development' && order.id && order.id.toString().includes('198033')) {
		}
		
		if (marketCode && marketWsList && marketWsList.length > 0) {
			// 直接使用 marketCode 匹配行情数据的 code（不区分大小写）
			const marketCodeLower = marketCode.toLowerCase();
			
			const marketData = marketWsList.find(item => {
				const itemCode = (item.code || '').toLowerCase();
				return itemCode === marketCodeLower;
			});
			
		if (marketData) {
			// 尝试多个可能的价格字段
			const price = marketData.price || marketData.nowPrice || marketData.new_price || marketData.close;
			if (price) {
				return price; // 原样显示价格，不截断
			}
		} else {
			// 调试日志 - 没找到匹配
		}
	}
	
	// 备用：返回订单中保存的价格
	const price = order.update_price || order.currentPrice || order.sellPrice;
	return price || '-';
	},
	isBuyDirection(row) {
		// 判断买卖方向的逻辑 - 兼容多种字段和值
		// 期权：type=1 是买涨，type=2 是买跌
		// 合约：type=0 是买入，type=1 是卖出
		// direction 字段类似
		// type_name 也可能包含多种表达方式
		if (this.localMainOrderType === 'options') {
			// 期权模式：1=买涨，2=买跌
			return row.type === 1 || row.type === '1' || 
			       row.direction === 1 || row.direction === '1' ||
			       (row.type_name && ['买涨', 'Buy Up'].includes(row.type_name))
		} else {
			// 合约模式：0=买入，1=卖出
			return row.type === 0 || row.type === '0' || 
			       row.direction === 0 || row.direction === '0' ||
			       (row.type_name && ['买入', 'Buy', 'Long'].includes(row.type_name))
		}
	},
	getOptionsCountdown(row) {
		// 计算期权倒计时 - 与手机端逻辑一致
		if (!row || !row.limitTime) return 0
		
		// 尝试从多个可能的字段获取创建时间
		const createTimeStr = row.createTime || row.buyTime || row.updateTime
		if (!createTimeStr) {
			return 0
		}
		
		// ✅ 获取时区偏移信息
		const systemTimezone = this.$store.state.systemTimezone || {}
		let serverTimezoneOffsetHours = systemTimezone.offsetHours || 1
		
		// ✅ 临时修正：如果后端返回的是UTC+1，检查是否应该是夏令时UTC+2
		// 欧洲夏令时通常是3月最后一个周日到10月最后一个周日
		if (serverTimezoneOffsetHours === 1) {
			const now = new Date()
			const month = now.getMonth() + 1 // 1-12
			const day = now.getDate()
			
			// 简单判断：3月-10月期间可能是夏令时（更精确的判断需要计算最后一个周日）
			if (month >= 4 && month <= 9) {
				// 4-9月肯定是夏令时
				serverTimezoneOffsetHours = 2
				console.log('⚠️ PC端检测到夏令时期间，将服务器时区从UTC+1修正为UTC+2')
			} else if (month === 3 || month === 10) {
				// 3月和10月需要更精确判断，这里简化处理
				serverTimezoneOffsetHours = 2
				console.log('⚠️ PC端检测到可能的夏令时期间，将服务器时区从UTC+1修正为UTC+2')
			}
		}
		
		// ✅ 解析服务器时间字符串，并转换为正确的时间戳
		// 服务器时间是服务器本地时区（如UTC+1），但JavaScript会按客户端时区解析
		// 需要修正这个时区差异
		const parsedTime = new Date(createTimeStr.replace(/-/g, '/').replace(/\.\d+/, '')).getTime()
		
		// 计算客户端时区偏移（分钟）
		const clientTimezoneOffsetMinutes = new Date().getTimezoneOffset()
		const clientTimezoneOffsetHours = -clientTimezoneOffsetMinutes / 60 // 转换为小时，负号是因为getTimezoneOffset返回的是负值
		
		// ✅ 计算时区差异（小时）- 修正方向
		const timezoneDiffHours = serverTimezoneOffsetHours - clientTimezoneOffsetHours
		
		// ✅ 修正时间戳：减去时区差异（由于计算方向已修正，这里保持减法）
		// 例如：服务器UTC+1，客户端UTC+8，差异 = 1-8 = -7
		// 修正 = parsedTime - (-7 * 3600000) = parsedTime + 25200000
		const createTime = parsedTime - (timezoneDiffHours * 3600000)
		
		// 验证时间戳是否有效
		if (isNaN(createTime)) {
			return 0
		}
		
		// 获取当前客户端时间
		const clientNow = this.currentTime
		
		// 计算从订单创建到现在已经过去的时间
		const elapsedTime = clientNow - createTime
		
		// 计算剩余时间（秒）
		const remainingSeconds = Math.max(0, Math.floor((row.limitTime * 1000 - elapsedTime) / 1000))
		
		return remainingSeconds
	},
		startCountdownTimer() {
			// 清除旧的定时器
			if (this.countdownTimer) {
				clearInterval(this.countdownTimer)
			}
			
	// 启动新的定时器，每秒更新一次
	this.countdownTimer = setInterval(() => {
		this.currentTime = Date.now()
		// 更新期权订单的实时收益波动
		this.updateOptionsProfitFluctuation()
		// 更新总盈亏（基于实时波动）
		this.updateTotalProfitLoss()
		// 更新tableKey以强制表格重新渲染（确保getRealTimePrice被重新调用）
		this.tableKey++
		// 强制更新视图以更新倒计时显示
		this.$forceUpdate()
	}, 1000)
	},
	// 更新总盈亏（基于实时波动的盈亏）
	updateTotalProfitLoss() {
		if (this.localTabIndex === 0 && this.indexList && this.indexList.length > 0) {
			// 使用实时波动的盈亏计算总盈亏
			const totalPnl = this.indexList.reduce((sum, item) => {
				const realTimePnl = this.getOptionsRealTimeProfit(item)
				return sum + realTimePnl
			}, 0)
			
			// 通过事件通知父组件更新总盈亏
			this.$emit('update-total-pnl', totalPnl)
		}
	},
	updateOptionsProfitFluctuation() {
		// 为订单计算基于真实价格的盈亏
		if (this.indexList && this.indexList.length > 0) {
			this.indexList.forEach(order => {
				// 持仓中的订单：合约status=1，期权status=0
				const isPositionOpen = this.localMainOrderType === 'contract' ? order.status === 1 : order.status === 0
				
				if (order.id && isPositionOpen) {
					if (this.localMainOrderType === 'contract') {
						// 合约：基于实时价格计算真实盈亏
						const realTimeProfit = this.calculateRealTimeProfit(order)
						this.$set(this.optionsProfitFluctuation, order.id, realTimeProfit)
					} else {
						// 期权：基于实时价格判断方向，计算预期盈亏
						const realTimeProfit = this.calculateOptionRealTimeProfit(order)
						this.$set(this.optionsProfitFluctuation, order.id, realTimeProfit)
					}
				}
			})
		}
	},
	
	// 计算合约订单的实时盈亏
	calculateRealTimeProfit(order) {
		if (!order) return 0
		
		// 获取实时价格
		const currentPrice = parseFloat(this.getRealTimePrice(order)) || 0
		const openPrice = parseFloat(order.buyPrice || order.price || 0)
		
		if (!currentPrice || !openPrice) return 0
		
		// 获取手数和合约乘数
		const hands = parseFloat(order.hands || order.number || 0)
		const contractSize = parseFloat(order.contractSize || 1) // 🔑 从后端返回的合约乘数
		
		// 判断方向：0=买入(做多), 1=卖出(做空)
		const type = order.type
		
		// 计算价差
		let priceDiff = 0
		if (type === 0 || type === '0') {
			// 做多：当前价格 - 开仓价格
			priceDiff = currentPrice - openPrice
		} else {
			// 做空：开仓价格 - 当前价格
			priceDiff = openPrice - currentPrice
		}
		
		// 盈亏 = 价差 × 手数 × 合约乘数
		// 注意：不是乘以杠杆！杠杆只影响保证金，不影响盈亏
		const profit = priceDiff * hands * contractSize
		
		return profit
	},
	
	// 计算期权订单的实时预期盈亏
	calculateOptionRealTimeProfit(order) {
		if (!order) return 0
		
		// 获取实时价格和开仓价格
		const currentPrice = parseFloat(this.getRealTimePrice(order)) || 0
		const openPrice = parseFloat(order.buyPrice || order.price || 0)
		
		if (!currentPrice || !openPrice) {
			// 如果没有价格，返回后端的盈亏
			return parseFloat(order.income || order.upsdowns || order.profit || 0)
		}
		
		// 获取投资金额
		const investAmount = parseFloat(order.amount || order.caution_money || 0)
		
		if (!investAmount) return 0
		
		// 获取收益率（通常期权收益率在80%-95%之间，这里从订单数据中获取，默认85%）
		// 期权的收益率可能存储在不同字段中
		let profitRate = 0.85 // 默认85%
		
		// 尝试从订单中获取收益率
		if (order.profitRate) {
			profitRate = parseFloat(order.profitRate) / 100
		} else if (order.rate) {
			profitRate = parseFloat(order.rate) / 100
		} else if (order.incomeRate) {
			profitRate = parseFloat(order.incomeRate) / 100
		}
		
		// 判断方向：1=买涨, 2=买跌
		const type = order.type
		
		// 根据实时价格判断当前是否盈利
		let isWinning = false
		if (type === 1 || type === '1') {
			// 买涨：当前价格 > 开仓价格 = 盈利
			isWinning = currentPrice > openPrice
		} else if (type === 2 || type === '2') {
			// 买跌：当前价格 < 开仓价格 = 盈利
			isWinning = currentPrice < openPrice
		}
		
		// 计算预期盈亏
		if (isWinning) {
			// 盈利：投资额 × 收益率
			return investAmount * profitRate
		} else {
			// 亏损：-投资额
			return -investAmount
		}
	},
	
	getOptionsRealTimeProfit(order) {
		// 获取订单的实时真实盈亏
		if (!order || !order.id) return 0
		
		// 如果订单已结束（期权倒计时结束或合约已平仓），返回后端的实际收益
		if (this.localMainOrderType === 'options') {
			// 期权：倒计时结束或已平仓（status=1），返回后端收益
			if (this.getOptionsCountdown(order) <= 0 || order.status === 1) {
				return parseFloat(order.income || order.upsdowns || order.profit || 0)
			}
		} else {
			// 合约：已平仓（status=2），返回后端收益
			if (order.status === 2) {
				return parseFloat(order.upsdowns || order.income || 0)
			}
		}
		
		// 持仓中的订单：返回前端计算的实时盈亏
		if (this.optionsProfitFluctuation.hasOwnProperty(order.id)) {
			return this.optionsProfitFluctuation[order.id]
		}
		
		// 如果还没有计算过，返回后端的初始值
		return parseFloat(order.upsdowns || order.income || 0)
	},
		stopCountdownTimer() {
			if (this.countdownTimer) {
				clearInterval(this.countdownTimer)
				this.countdownTimer = null
			}
		},
		
		// 显示止盈止损设置弹窗
		showTpSlModal(order) {
			if (!order || !order.id) {
				console.error('❌ 订单数据无效')
				return
			}
			
			// 只能在合约持仓中修改止盈止损
			if (this.localMainOrderType !== 'contract' || this.localTabIndex !== 0) {
				this.$message.warning(this.$t('Trading.onlyContractPositions') || '只能修改合约持仓的止盈止损')
				return
			}
			
			this.selectedOrderForTpSl = order
			
			// 初始化表单数据
			const tp = parseFloat(order.target_profit_price || order.stopLoss || 0)
			const sl = parseFloat(order.stop_loss_price || order.stopProfit || 0)
			
			this.tpSlForm = {
				tpEnabled: tp > 0,
				tpValue: tp > 0 ? tp : 0,
				slEnabled: sl > 0,
				slValue: sl > 0 ? sl : 0
			}
			
			this.showTpSlDialog = true
		},
		
		// 提交止盈止损设置
	async handleSubmitTpSl() {
		if (!this.selectedOrderForTpSl || !this.selectedOrderForTpSl.id) {
			this.$message.error(this.$t('common.invalidOrder') || '订单信息无效')
			return
		}
		
		// ✅ 验证止盈止损价格合理性
		const orderType = this.selectedOrderForTpSl.type // 0=买多, 1=卖空
		const openPrice = parseFloat(this.selectedOrderForTpSl.price || this.selectedOrderForTpSl.buyPrice || 0)
		
		if (openPrice > 0) {
			// 买多订单
			if (orderType === 0) {
				// 止盈价必须高于开仓价
				if (this.tpSlForm.tpEnabled && this.tpSlForm.tpValue > 0 && this.tpSlForm.tpValue <= openPrice) {
					this.$message.error(this.$t('Trading.buyTpMustHigher') || '买入(做多)止盈值不能低于开仓值')
					return
				}
				// 止损价必须低于开仓价
				if (this.tpSlForm.slEnabled && this.tpSlForm.slValue > 0 && this.tpSlForm.slValue >= openPrice) {
					this.$message.error(this.$t('Trading.buySlMustLower') || '买入(做多)止损值不能高于开仓值')
					return
				}
			}
			// 卖空订单
			else if (orderType === 1) {
				// 止盈价必须低于开仓价
				if (this.tpSlForm.tpEnabled && this.tpSlForm.tpValue > 0 && this.tpSlForm.tpValue >= openPrice) {
					this.$message.error(this.$t('Trading.sellTpMustLower') || '卖出(做空)止盈值不能高于开仓值')
					return
				}
				// 止损价必须高于开仓价
				if (this.tpSlForm.slEnabled && this.tpSlForm.slValue > 0 && this.tpSlForm.slValue <= openPrice) {
					this.$message.error(this.$t('Trading.sellSlMustHigher') || '卖出(做空)止损值不能低于开仓值')
					return
				}
			}
		}
		
		this.modifyingTpSl = true
			
			try {
				const params = {
					orderId: this.selectedOrderForTpSl.id,
					stopLoss: this.tpSlForm.slEnabled ? this.tpSlForm.slValue : 0, // 止损价格
					stopProfit: this.tpSlForm.tpEnabled ? this.tpSlForm.tpValue : 0 // 止盈价格
				}
				
				const res = await updateContractTpSl(params)
				
				if (res && res.code === 200) {
					// 关闭弹窗
					this.showTpSlDialog = false
					
					// 显示成功提示框
					this.successMessage = this.$t('Trading.tpslUpdateSuccess') || '止盈止损设置成功'
					this.showSuccessModal = true
					
					// 2秒后自动关闭提示
					setTimeout(() => {
						this.showSuccessModal = false
					}, 2000)
					
					// 通知父组件刷新订单列表
					this.$emit('refresh-orders')
					
			} else {
				const errorMsg = res.message || res.msg || this.$t('Trading.tpslUpdateError') || '设置失败'
				// ✅ 只在有错误信息时才显示提示
				if (errorMsg) {
					this.$message.error(errorMsg)
				}
			}
		} catch (error) {
			console.error('❌ 修改止盈止损失败:', error)
			
			let errorMsg = this.$t('Trading.tpslUpdateError') || '设置失败，请重试'
			if (error.response) {
				errorMsg = error.response.data?.message || error.response.data?.msg || errorMsg
			}
			
			// ✅ 只在有错误信息时才显示提示
			if (errorMsg) {
				this.$message.error(errorMsg)
			}
			} finally {
				this.modifyingTpSl = false
			}
		}
	}
}
</script>

<style scoped>
/* 订单管理容器样式 */
.order-management-container {
	width: calc(100% - 24px);
	min-height: 400px;
	background: var(--card-bg, #ffffff);
	padding: 20px;
	margin: 30px 12px 18px 12px;
	overflow: visible;
	border-radius: 12px;
	transition: background-color 0.3s ease;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
	border: 1px solid rgba(0, 0, 0, 0.02);
}

/* 主选项卡样式（合约/期权）*/
.main-tab-item {
	padding: 12px 24px;
	cursor: pointer;
	font-size: 15px;
	font-weight: 600;
	border-bottom: 3px solid var(--border-light, transparent);
	transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
	color: var(--text-secondary);
}

.main-tab-item:hover {
	color: var(--text-primary);
}

.main-tab-active {
	color: var(--primary-color, #0156DC) !important;
	border-bottom-color: var(--primary-color, #0156DC) !important;
}

/* 子选项卡样式 */
.tab-item {
	padding: 8px 16px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 500;
	border-bottom: 2px solid var(--border-light, transparent);
	transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
	color: var(--text-secondary);
}

.tab-item:hover {
	color: var(--text-primary);
}

.tab-active {
	padding: 8px 16px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 500;
	color: var(--primary-color, #0156DC) !important;
	border-bottom: 2px solid var(--primary-color, #0156DC) !important;
	transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
}

/* 空状态样式 */
.empty-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 40px 20px;
}

.empty-image {
	width: 120px;
	height: 120px;
	margin-bottom: 16px;
	opacity: 0.5;
	transition: opacity 0.3s ease, filter 0.3s ease;
}

/* 黑夜模式下的图片滤镜 */
@media (prefers-color-scheme: dark) {
	.empty-image {
		filter: brightness(0.8) contrast(0.9);
	}
}

.empty-text {
	color: var(--text-tertiary);
	font-size: 14px;
}

/* 方向标签样式 */
.direction-tag {
	display: inline-block;
	padding: 4px 16px;
	color: #ffffff;
	text-align: center;
	border-radius: 12px;
	font-size: 12px;
	font-weight: 500;
	min-width: 50px;
}

.direction-buy {
	background-color: var(--primary-color, #0156DC);
}

.direction-sell {
	background-color: var(--danger-color, #f23c48);
}

/* 盈亏显示样式 */
.profit-value {
	font-size: 12px;
	font-weight: 500;
}

.profit-positive {
	color: var(--primary-color, #0156DC);
}

.profit-negative {
	color: var(--danger-color, #F23C48);
}

/* 期权倒计时样式 */
.countdown-display {
	background: var(--danger-color, #ff4444);
	color: #ffffff;
	padding: 2px 8px;
	border-radius: 12px;
	font-size: 12px;
	font-weight: 500;
	text-align: center;
	display: inline-block;
	min-width: 40px;
}

.countdown-finished {
	color: var(--text-tertiary);
	font-size: 12px;
	text-align: left;
}

/* 主选项卡样式 */
.main-tab-item {
	color: var(--text-secondary, #666);
	background: transparent;
	transition: all 0.2s;
}

.main-tab-item:hover {
	color: var(--primary-color, #0156DC);
	background: var(--hover-bg, rgba(1, 102, 252, 0.05));
}

.main-tab-active {
	color: var(--primary-color, #0156DC) !important;
	border-bottom-color: var(--primary-color, #0156DC) !important;
	font-weight: 600 !important;
}

/* 子选项卡样式 */
.tab-item {
	color: var(--text-secondary, #666);
	transition: all 0.2s;
}

.tab-item:hover {
	color: var(--primary-color, #0156DC);
	background: var(--hover-bg, rgba(1, 102, 252, 0.05));
}

.tab-active {
	color: var(--primary-color, #0156DC) !important;
	border-bottom-color: var(--primary-color, #0156DC) !important;
	font-weight: 600 !important;
}

/* 统计信息样式 */
.positive {
	color: var(--primary-color, #0156DC) !important;
}

.negative {
	color: var(--danger-color, #f23c48) !important;
}

/* 止盈止损弹窗样式 */
.tpsl-dialog {
	z-index: 3000 !important;
}

.tpsl-dialog >>> .el-dialog__wrapper {
	z-index: 3000 !important;
	pointer-events: auto !important;
}

.tpsl-dialog >>> .el-dialog {
	z-index: 3001 !important;
	pointer-events: auto !important;
}

.tpsl-dialog >>> .el-dialog__header,
.tpsl-dialog >>> .el-dialog__body,
.tpsl-dialog >>> .el-dialog__footer {
	pointer-events: auto !important;
}

.tpsl-dialog >>> .v-modal {
	z-index: 2999 !important;
}

.tpsl-dialog-content {
	padding: 10px 0;
	pointer-events: auto !important;
}

.tpsl-dialog-content >>> .el-checkbox,
.tpsl-dialog-content >>> .el-input,
.tpsl-dialog-content >>> .el-button {
	pointer-events: auto !important;
}

.order-info-header {
	margin-bottom: 20px;
	padding: 16px;
	background: var(--bg-secondary, #f5f7fa) !important;
	border-radius: 8px;
}

.order-info-header .info-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
}

.order-info-header .info-row:last-child {
	margin-bottom: 0;
}

.order-info-header .label {
	color: var(--text-secondary, #666) !important;
	font-size: 14px;
}

.order-info-header .value {
	color: var(--text-primary, #333) !important;
	font-size: 14px;
	font-weight: 600;
}

.tpsl-form-item {
	margin-bottom: 20px;
}

.tpsl-checkbox-row {
	margin-bottom: 8px;
}

.tpsl-input {
	width: 100%;
}

/* 隐藏数字输入框的增减按钮 */
.tpsl-dialog >>> .el-input__inner[type="number"]::-webkit-inner-spin-button,
.tpsl-dialog >>> .el-input__inner[type="number"]::-webkit-outer-spin-button {
	-webkit-appearance: none !important;
	margin: 0 !important;
}

.tpsl-dialog >>> .el-input__inner[type="number"] {
	-moz-appearance: textfield !important;
	appearance: textfield !important;
}

/* 弹窗按钮样式 */
.dialog-footer {
	display: flex;
	padding: 20px;
}

.tpsl-dialog >>> .tpsl-full-btn,
.tpsl-dialog >>> .tpsl-full-btn.el-button--primary {
	width: 100% !important;
	height: 44px !important;
	font-size: 16px !important;
	font-weight: 600 !important;
	background: var(--primary-color, #0156DC) !important;
	border-color: var(--primary-color, #0156DC) !important;
	border-radius: 8px !important;
	color: #ffffff !important;
}

.tpsl-dialog >>> .tpsl-full-btn:hover,
.tpsl-dialog >>> .tpsl-full-btn.el-button--primary:hover,
.tpsl-dialog >>> .tpsl-full-btn:focus,
.tpsl-dialog >>> .tpsl-full-btn.el-button--primary:focus {
	background: var(--primary-color, #0156DC) !important;
	border-color: var(--primary-color, #0156DC) !important;
	color: #ffffff !important;
	opacity: 0.9;
}

.tpsl-dialog >>> .tpsl-full-btn:active,
.tpsl-dialog >>> .tpsl-full-btn.el-button--primary:active {
	background: var(--primary-color, #0156DC) !important;
	border-color: var(--primary-color, #0156DC) !important;
	color: #ffffff !important;
	opacity: 0.8;
}

/* 黑夜模式适配 */
.tpsl-dialog >>> .el-dialog {
	background: var(--card-bg, #ffffff) !important;
}

.tpsl-dialog >>> .el-dialog__header {
	background: var(--card-bg, #ffffff) !important;
	border-bottom: none !important;
}

.tpsl-dialog >>> .el-dialog__title {
	color: var(--text-primary, #333) !important;
	font-weight: 600;
}

.tpsl-dialog >>> .el-dialog__body {
	background: var(--card-bg, #ffffff) !important;
	overflow-y: auto !important;
}

/* 隐藏滚动条但保持滚动功能 */
.tpsl-dialog >>> .el-dialog__body::-webkit-scrollbar {
	width: 0 !important;
	display: none !important;
}

.tpsl-dialog >>> .el-dialog__body {
	-ms-overflow-style: none !important;  /* IE and Edge */
	scrollbar-width: none !important;  /* Firefox */
}

.tpsl-dialog >>> .el-dialog__footer {
	background: var(--card-bg, #ffffff) !important;
	border-top: none !important;
	padding: 0 !important;
}

.tpsl-dialog >>> .el-dialog__close {
	color: var(--text-secondary, #666) !important;
}

.tpsl-dialog >>> .el-dialog__close:hover {
	color: var(--text-primary, #333) !important;
}

.tpsl-dialog >>> .el-checkbox__label {
	color: var(--text-primary, #333) !important;
}

.tpsl-dialog >>> .el-checkbox__inner {
	background-color: var(--card-bg, #ffffff) !important;
	border-color: var(--border-color, #dcdfe6) !important;
}

.tpsl-dialog >>> .el-checkbox__input.is-checked .el-checkbox__inner {
	background-color: var(--primary-color, #0156DC) !important;
	border-color: var(--primary-color, #0156DC) !important;
}

.tpsl-dialog >>> .el-input__inner {
	background-color: var(--card-bg, #ffffff) !important;
	border-color: var(--border-color, #dcdfe6) !important;
	color: var(--text-primary, #333) !important;
}

.tpsl-dialog >>> .el-input__inner:focus {
	border-color: var(--primary-color, #0156DC) !important;
}

.tpsl-dialog >>> .el-input__inner:disabled {
	background-color: var(--bg-secondary, #f5f7fa) !important;
	color: var(--text-tertiary, #999) !important;
}

/* 成功提示框样式 */
.success-modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
}

.success-modal-content {
	background: #4a5568;
	border-radius: 12px;
	padding: 40px 60px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	animation: scaleIn 0.3s ease-out;
}

.success-icon {
	width: 60px;
	height: 60px;
	background: #48bb78;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.checkmark-simple {
	width: 32px;
	height: 32px;
	fill: white;
}

.success-text {
	font-size: 18px;
	font-weight: 600;
	color: white;
	text-align: center;
}

@keyframes scaleIn {
	from {
		transform: scale(0.8);
		opacity: 0;
	}
	to {
		transform: scale(1);
		opacity: 1;
	}
}
</style>

<!-- Element UI 表格全局样式（非 scoped，用于黑夜模式适配） -->
<style>
/* Element UI Table 黑夜模式适配 - 彻底禁用所有边框 */
.el-table {
	background-color: var(--card-bg, #ffffff) !important;
	color: var(--text-primary, #333) !important;
	border: none !important;
	border-top: none !important;
	border-bottom: none !important;
	border-left: none !important;
	border-right: none !important;
	transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease !important;
	box-shadow: none !important;
}

.el-table::before,
.el-table::after {
	display: none !important;
	background-color: transparent !important;
	height: 0 !important;
	border: none !important;
}

.el-table th.el-table__cell {
	background-color: var(--card-bg, #ffffff) !important;
	color: var(--text-secondary, #666) !important;
	border: none !important;
	border-bottom: none !important;
	border-top: none !important;
	border-left: none !important;
	border-right: none !important;
	transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease !important;
	box-shadow: none !important;
}

.el-table td.el-table__cell {
	background-color: var(--card-bg, #ffffff) !important;
	color: var(--text-primary, #333) !important;
	border: none !important;
	border-bottom: none !important;
	border-top: none !important;
	border-left: none !important;
	border-right: none !important;
	transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease !important;
	box-shadow: none !important;
}

.el-table__row {
	background-color: var(--card-bg, #ffffff) !important;
	border: none !important;
	transition: background-color 0.3s ease, border-color 0.3s ease !important;
}

.el-table__body,
.el-table__body-wrapper,
.el-table__header,
.el-table__header-wrapper,
.el-table__footer,
.el-table__footer-wrapper {
	border: none !important;
	box-shadow: none !important;
}

.el-table--border,
.el-table--group {
	border: none !important;
}

.el-table--border::after,
.el-table--group::after,
.el-table::before {
	display: none !important;
}

.el-table--border .el-table__cell,
.el-table__body-wrapper .el-table__body .el-table__row .el-table__cell {
	border-right: none !important;
}

.el-table__row:hover > td {
	background-color: var(--hover-bg, rgba(1, 102, 252, 0.05)) !important;
}

.el-table__empty-block {
	background-color: var(--card-bg, #ffffff) !important;
	transition: background-color 0.3s ease;
}

.el-table__empty-text {
	color: var(--text-tertiary, #999) !important;
}

/* 表格固定列的背景色 */
.el-table__fixed,
.el-table__fixed-right {
	background-color: var(--card-bg, #ffffff) !important;
}

.el-table__fixed::before,
.el-table__fixed-right::before {
	background-color: transparent !important;
}

/* 表格边框 */
.el-table--border,
.el-table--group {
	border-color: transparent !important;
}

.el-table--border th.el-table__cell,
.el-table--border td.el-table__cell {
	border-right: none !important;
}

.el-table--border .el-table__cell:first-child .cell {
	padding-left: 10px;
}

/* 表格体 */
.el-table__body-wrapper {
	background-color: var(--card-bg, #ffffff) !important;
}

/* 空数据提示 */
.el-table__empty-block {
	min-height: 200px !important;
}
</style>
